import {useState} from "#app";
import { gsap } from "gsap"
export default defineNuxtPlugin(nuxtApp => {
  const navOpen = useState('false')
  navOpen.value = false
  function toggleNav() {
    if (navOpen.value === true) {
      closeNav()
    } else {
      openNav()
    }
  }
  function closeNav() {
    navOpen.value = !navOpen.value
    gsap.to('.nav-anim', {
      delay: 0,
      duration: 0.2,
      opacity: 0,
      x: '6rem',
      stagger: 0.1,
      ease: "back.inOut"
    })
  }
  function openNav() {
    navOpen.value = !navOpen.value
    gsap.to('.nav-anim', {
      delay: 0.1,
      duration: 0.4,
      opacity: 1,
      x: 0,
      stagger: 0.25,
      ease: "back.inOut"
    })
  }

  return {
    provide: { toggleNav }
  }
})
